/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ClickableIcon.vue?vue&type=template&id=11e57e38"
import script from "./ClickableIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClickableIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClickableIcon.vue?vue&type=style&index=0&id=11e57e38&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports